import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import Slider from "react-slick";
import { Container } from "react-bootstrap";
import { FaQuoteLeft, FaStar, FaRegStar } from "react-icons/fa";
import client from "../../../assets/images/feature/0.png";
import client1 from "../../../assets/images/feature/1.png";

const TestimonialSection = () => {
  const [cmsData, setCmsData] = useState([]);
  const [status, setStatus] = useState(null);
  const [imagePath, setimagePath] = useState([]);
  const [fooder, setfooder] = useState("");

  useEffect(() => {
    fetchCMSData();
    footerdata();
  }, []);

  const fetchCMSData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/testimonial-list`
      );
      setCmsData(res.data.data); // Save entire list
      setStatus(res.data.status);
      setimagePath(res.data.imagePath);
    } catch (error) {
      console.error("Error fetching CMS data", error);
    }
  };
  const footerdata = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/site-setting`
      );
      setfooder(res.data.data);
      // setstatus(res.data.status);
    } catch (error) {}
  };

    const testimonialData =
    cmsData.length === 1 ? [...cmsData, ...cmsData, ...cmsData] : cmsData;
  // Filter items by type
  const aboutUsItems = cmsData.filter((item) => item.type === "test_imonials");
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    autoplay: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <>
      {fooder.testmotionalpermission == 1 ? (
        <section className="text-center testommonial">
          <Container>
            <Slider {...settings}>
              {testimonialData.map((item, index) => (
                <div key={index} className="p-3">
                  <div className="client">
                    <div className="mb-3 quote">
                      <FaQuoteLeft size={30} />
                    </div>
                    <h5 className="mb-4">{item.description}</h5>
                    <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
                      <img
                        src={item?.image ? `${imagePath}${item.image}` : ""}
                        alt={item.name}
                        className="author"
                      />
                      <div className="text-start text-white">
                        <div className="d-flex mb-2">
                          {[...Array(5)].map((_, i) =>
                            i < item.rating ? (
                              <FaStar key={i} className="text-warning me-1" />
                            ) : (
                              <FaRegStar key={i} className="text-muted me-1" />
                            )
                          )}
                        </div>
                        <h6 className="mb-0">{item.name}</h6>
                        <small>{item.degination}</small>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </Container>
        </section>
      ) : (
        ""
      )}
    </>
  );
};

export default TestimonialSection;
